import { FormGroup } from '@angular/forms';
import { TNil } from '@app/app.interface';
import { ICampaignCreatorForm, ICtaForm } from '@campaign-form/campaign-form.interface';

export interface IDeliverableFlowDialogData {
  createMode?: boolean;
  creatorIds: string[];
  ctasValues: FormGroup<ICtaForm>['value'][];
  campaignCreatorsValue: FormGroup<ICampaignCreatorForm>['value'][];
  ctaValues?: FormGroup<ICtaForm>['value'];
  isTemplateSettings?: boolean;
  startingStep?: EDeliverableFlowStep;
  customModeInitialCreatorId?: string | TNil;
}

export interface IDeliverableFlowDialogResult {
  ctaFormValues?: FormGroup<ICtaForm>['value'] | TNil;
  newPlatformAddedCreatorIds?: string[];
  discarded?: boolean;
}

export interface IHeaderStep {
  label: string;
  step: EDeliverableFlowStep;
}

export enum EDeliverableFlowStep {
  platform = 'platform',
  deliverable = 'deliverable',
  execution = 'execution',
  kpis = 'kpis',
  review = 'review',
}
